export default "__VITE_ASSET__DzWGFPeH__"